import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useMembershipSoldReportCsv({
  api,
  tz,
}: {
  api: ApiType;
  membership?: number[];
  tz: string;
}) {
  return useMutation({
    mutationFn: async ({
      startDate,
      endDate,
      membershipIncluded,
      membershipExcluded,
    }: {
      startDate: string;
      endDate: string;
      membershipIncluded?: number[];
      membershipExcluded?: number[];
    }) => {
      const utcStart = zonedTimeToUtc(startDate as string, tz);
      const utcEnd = zonedTimeToUtc(endDate as string, tz);
      return await api.memberApi.membershipSoldCsv({
        dateFrom: utcStart,
        dateTo: utcEnd,
        membershipIncluded,
        membershipExcluded,
      });
    },
  });
}
